import React from 'react';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import { grey } from 'globals/colors';

export const WrapperBox = withStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
  },
}))(Box);

export interface LineProps extends BoxProps {
  active: boolean;
}

export const Line = withStyles(({ spacing, transitions }) => ({
  root: {
    width: '100%',
    margin: spacing(0, 0.5),
    height: spacing(0.5),
    borderRadius: spacing(0.25),
    transition: transitions.create(['background-color']),
  },
}))(({ bgcolor, active, ...otherProps }: LineProps) => (
  <Box {...otherProps} bgcolor={active ? bgcolor : grey.V4} />
));
